<template>
    <div @click="clickHandler">
        <component :is="component" class="custom" :data="data" :row="row"></component>
    </div>
</template>

<script>
export default {
    name: "Custom",
    props: ["data", "component", "row"],
    methods: {
        clickHandler(event) {
            this.$emit("colClick", {
                event: event,
                type: "Custom"
            });
        }
    }
};
</script>

<style lang="less" scoped>
.custom {
}
</style>
